import script from "./Availability.vue?vue&type=script&setup=true&lang=ts"
export * from "./Availability.vue?vue&type=script&setup=true&lang=ts"

import "./Availability.vue?vue&type=style&index=0&id=17af9aca&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17af9aca"]])

export default __exports__